import React, { useState, useCallback } from 'react';
import './signup.css';
import { useNavigation } from '../../../../shared/utils/useNavigation';
import AccountOption from '../../../../features/cards/AccountOption';
import { ACCOUNT_TYPES } from '../../../../shared/constants/common';
import { ACCOUNT_OPTIONS } from '../../../../shared/constants/data';
import HeaderSection from '../../../../components/layout/header';

const ModernSignup = (history) => {
  const navigate = useNavigation();

  const [selectedAccountType, setSelectedAccountType] = useState(null);

  const handleAccountTypeSelect = (type) => {
    setSelectedAccountType(type);

    // Navigate based on account type
    const navigationMap = {
      [ACCOUNT_TYPES.CREATOR]: () => navigate.toCreatorSignup(),
      [ACCOUNT_TYPES.SUBSCRIBER]: () => navigate.toSubscriberSignup()
    };

    navigationMap[type]?.();
  };

  const handleBack = () => {
    navigate.toLogin();
  };

  const handleLoginLink = () => {
    navigate.toLogin();
  };

  const handleTermsClick = () => {
    navigate.toTerms();
  };

  const handlePrivacyClick = () => {
    navigate.toPrivacy();
  };

  return (
    <div className={`modern-signup-screen`}>
      {/* Header */}
      <HeaderSection
        type="text"
        title="Create an Account"
        handleBack={handleBack}
      />

      <main className="modern-signup-main">
        <div className="modern-signup-bg-effects">
          <div className="modern-signup-bg-gradient"></div>
          <div className="modern-signup-bg-blur-1"></div>
          <div className="modern-signup-bg-blur-2"></div>
          <div className="modern-signup-bg-blur-3"></div>
        </div>

        <div className="modern-signup-container">
          <div className="modern-signup-account-types">
            {ACCOUNT_OPTIONS.map((option) => (
              <AccountOption
                key={option.type}
                option={option}
                isSelected={selectedAccountType === option.type}
                onSelect={handleAccountTypeSelect}
              />
            ))}
          </div>

          <div className="modern-signup-login-link">
            <p className="modern-signup-login-text">
              Already have an account?
              <span
                className="modern-signup-login-link-text"
                onClick={handleLoginLink}
              >
                Log in
              </span>
            </p>
          </div>

          <div className="modern-signup-terms">
            <p className="modern-signup-terms-text">By creating an account, you agree to our</p>
            <div className="modern-signup-terms-links">
              <span
                className="modern-signup-terms-link"
                onClick={handleTermsClick}
              >
                Terms of Service
              </span>
              <span className="modern-signup-terms-and">and</span>
              <span
                className="modern-signup-terms-link"
                onClick={handlePrivacyClick}
              >
                Privacy Policy
              </span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ModernSignup; 